import { camelCaseToTitle } from '@treasury/utils';
import { OmegaListItem } from '@treasury/omega/view-models';
import { IssuedItemStatus, itemStatuses } from '@treasury/domain/channel/types/arp';

export const itemStatusOptions: OmegaListItem<IssuedItemStatus>[] = itemStatuses.map(status => ({
    value: status,
    text: camelCaseToTitle(status),
}));
